import React, { useState } from "react";
import { Container, TextField, Button, Alert, Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import Footer from "../../Footer";
import { useI18n } from "../../../i18n/I18nContext";
import { useAuth } from "../../utils/AuthContext"; // Pfad ggf. anpassen!
import LanguageSwitcher from "../../common/LanguageSwitcher";

const BackgroundContainer = styled(Box)({
    display: "flex",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
    backgroundImage: "url('/images/pexels-pixabay-415958.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center"
});

const FormWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "33%",
    marginLeft: "33%"
});

const FormContainer = styled(Container)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    padding: "2rem",
    borderRadius: "12px",
    width: "100%"
});

const backend = process.env.REACT_APP_BACKEND_URL || ""; // allow same-origin

function Login() {
    const { t } = useI18n();
    const { login } = useAuth();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLogin();
    };

    const handleLogin = async () => {
        try {
            const response = await fetch(`${backend}/login`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password })
            });

            const data = await response.json();

            if (response.ok) {
                // If backend returns a user, prefer: login(data.user)
                // Otherwise minimal: flip auth state
                login(data.user || true);

                setErrorMessage("");
            } else {
                setErrorMessage(data.error || t("login.error_invalid"));
            }
        } catch (error) {
            setErrorMessage(t("login.error_server"));
            console.error("Fehler:", error);
        }
    };

    return (
        <BackgroundContainer>
            <FormWrapper>
                <FormContainer component="form" onSubmit={handleSubmit}>
                    <Box
                        component="img"
                        src={`${process.env.PUBLIC_URL}/images/login_logo.png`}
                        alt="Leadgen"
                        sx={{ width: 250, height: "auto", borderRadius: "12px", boxShadow: 0 }}
                    />

                    <Typography variant="h1" sx={{ mt: 2, mb: 2, fontWeight: "bold", textAlign: "center" }}>
                        {t("login.title")}
                    </Typography>

                    <TextField
                        label={t("login.username")}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <TextField
                        label={t("login.password")}
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <Button variant="contained" type="submit" color="primary" fullWidth sx={{ mt: 2 }}>
                        {t("login.sign")}
                    </Button>

                    {errorMessage && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {errorMessage}
                        </Alert>
                    )}
                </FormContainer>
            </FormWrapper>
            <Footer />
        </BackgroundContainer>
    );
}

export default Login;
